export default __webpack_public_path__ + "static/mcneill-2443bbf22abbf0fff11a4d16ee2caa74.jpg";